module.exports = __webpack_public_path__ + "static/media/Icond-4.16296f6f.svg";